<template>
  <div class="container">
    <ToastPrime />
    <div class="table-display2">
      <div class="cell-display div2">
        <div class="card">
          <div class="formgrid grid">
            <div class="field col-12 md:col-2 text-left">
              <label for="shipName">{{ $t("shipName") }}</label>
              <p
                id="shipName"
                class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
               ><strong>{{ ship.name }}</strong></p>
            </div>
            <div class="field col-12 md:col-2 text-left">
              <label for="shipIMO">{{ $t("imoNumber") }}</label>
              <p
                id="shipIMO"
                class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
              ><strong>{{ ship.imo }}</strong></p>
            </div>
            <div class="field col-12 md:col-2 text-left">
              <label for="shipType">{{ $t("shipType") }}</label>
              <p
                id="shipType"
                class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
              ><strong>{{ ship.shipType.name }}</strong></p>
            </div>
            <div class="field col-12 md:col-2 text-left">
              <label for="shipGT">{{ $t("grossTonnage") }} - <strong>GT</strong> (t)</label>
              <p
                id="shipGT"
                class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
              ><strong>{{ ship.gt}}</strong></p>
            </div>
            <div class="field col-12 md:col-2 text-left">
              <label for="shipDWT">{{ $t("capacityDeadWeight") }} - <strong>DWT</strong> (t)</label>
              <p
                id="shipDWT"
                class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
              ><strong>{{ ship.dwt }}</strong></p>
            </div>
            <div class="field col-12 md:col-2 text-left">
              <label for="shipTotalDistance">{{ $t("totalDistance") }} (mn)</label>
              <p
                id="shipTotalDistance"
                class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
              ><strong>{{ ship.totalDistance}}</strong></p>
            </div>
            <div class="field col-12 md:col-2 text-left">
              <label for="iceClass">{{ $t("iceClass") }}</label>
              <p
                id="iceClass"
                class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
              ><strong>{{ ship.iceClassType.name}}</strong></p>
            </div>

            <div class="field col-12 md:col-2 text-left">
              <label for="labelModType">{{ $t("labelModType") }}</label>
              <p
                id="labelModType"
                class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
              ><strong>{{ modification.type.name}}</strong></p>
            </div>
          </div>

          <div class="field col-12 md:col-12 p-2"></div>
          <div class="input-box">
            <!--Fila de arriba-->
            <div style="display: flex;">
              <div class="field col-12 md:col-2 text-left">
                <label>{{ $t("neobuqInitialInvestment") }}<strong> (€)</strong>:</label>
                <input
                  v-model="initialInvestment"
                  type="number"
                  class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                />
              </div>
              <div class="field col-12 md:col-2 text-left">
                <label for="questionFinancingOption">{{ $t("neobuqFinancing") }}:</label>
                <SelectButton
                id="questionFinancingOption"
                name="selectedFinancingOption"
                v-model="selectedFinancingOption"
                :options="optionsFinancing"
                />
              </div>
              <div class="field col-12 md:col-2 text-left">
                <label>{{ $t("neobuqAmountToFinance") }}<strong> (€)</strong>:</label>
                <input v-if="selectedFinancingOption == 'Yes'"
                  v-model="amountToFinance"
                  type="number"
                  class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                />
                <p v-if="selectedFinancingOption == 'No'"
                   class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                >
                  <strong>0</strong>
                </p>
              </div>
              <div class="field col-12 md:col-2 text-left">
                <label>{{ $t("nominalInterest") }}<strong> (%)</strong>:</label>
                <input
                  v-model="nominalInterest"
                  type="number"
                  class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                />
              </div>
              <div class="field col-12 md:col-2 text-left">
                <label>{{ $t("neobuqAmortizationPeriod") }}:</label>
                <input
                  v-model="amortizationPeriod"
                  type="number"
                  class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                />
              </div>
            </div>
            <!--Fila de abajo-->
            <div style="display: flex;">
              <div class="field col-12 md:col-2 text-left">
                <label>{{ $t("annualDiscountRate") }}:</label>
                <input
                  v-model="annualDiscountRate"
                  type="number"
                  class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                />
              </div>
              <div class="field col-12 md:col-2 text-left">
                <label>{{ $t("dailyIncome") }} <strong> (€)</strong>:</label>
                <input
                  v-model="dailyIncome"
                  type="number"
                  class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                />
              </div>
              <div class="field col-12 md:col-2 text-left">
                <label>{{ $t("paralizationDays") }}:</label>
                <input
                  v-model="paralizationDays"
                  type="number"
                  class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                />
              </div>
              <div class="field col-12 md:col-3 text-left">
                <label>{{ $t("annualFuelPriceIncrease") }}<strong> (%)</strong>:</label>
                <input
                  v-model="annualFuelPriceIncrease"
                  type="number"
                  class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                />
              </div>
            </div>
          </div>

          <div class="field col-12 md:col-12 p-2"></div>
          <div style="display: flex;">
            <div style="display: flex;">
              <p for="yearOptions" style="padding-top: 20px; padding-right: 10px;"><strong>{{ $t("year") }}:</strong></p>
              <DropdownPrime
                id="yearOptions"
                v-model="yearSelected"
                :options="allYears"
                class="field col-3 md:col-10"
              />
            </div>

            <div style="text-align: left; padding-left: 4%;">
              <p><strong>{{ $t("ecoWarning") }}:</strong>{{ $t("ecoWarning_msg1") }} </p>
              <br>
              <p><strong>{{ $t("ecoWarning") }}:</strong>{{ $t("ecoWarning_msg2") }} </p>
            </div>

          </div>

          <!--DATOS POR AÑOS-->
          <div class="output-box" >
            <div v-for="(item, index) in filteredDataPerYear" :key="index" style="text-align: left;">
              <!--Valores pre modificación-->
              <div class="field col-12 md:col-7 text-left">
                <h2>{{ $t("headerPreMod") }}:</h2>
                <div class="field col-12 md:col-12 p-2"></div>
                <!--Tabla pre modificacion-->
                <table class="styled-table">
                  <thead>
                    <tr>
                      <th scope="col">{{ $t("fuelType") }}</th>
                      <th scope="col">{{ $t("fuelConsumption") }} <strong>(t)</strong></th>
                      <th scope="col">{{ $t("fuelPrice") }} <strong>(€/t)</strong></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(fuel, index) in item.fuelsPreMod" :key="index">
                    <td>
                      {{ fuel.fuel.name }}
                    </td>
                    <td>
                      {{ fuel.consumption }}
                    </td>
                    <td>
                      <input class="input-style" v-model="fuel.price" type="number" />
                    </td>
                    </tr>
                  </tbody>
                </table>
                <div class="field col-12 md:col-12 p-2"></div>
                <div>
                  <label>{{ $t("variousCosts") }}<strong> (€)</strong>:</label>
                  <input
                    v-model="item.preModVariousCosts"
                    type="number"
                    class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                  />
                </div>
              </div>
              <!--Valores post modificación-->
              <div class="field col-12 md:col-7 text-left">
                <h2>{{ $t("headerPostMod") }}:</h2>
                <div class="field col-12 md:col-12 p-2"></div>
                <!--Tabla post modificacion-->
                <table class="styled-table">
                  <thead>
                    <tr>
                      <th scope="col">{{ $t("fuelType") }}</th>
                      <th scope="col">{{ $t("fuelConsumption") }} <strong>(t)</strong></th>
                      <th scope="col">{{ $t("fuelPrice") }} <strong>(€/t)</strong></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(fuel, index) in item.fuelsPostMod" :key="index">
                    <td>
                      {{ fuel.fuel.name }}
                    </td>
                    <td>
                      {{ fuel.consumption }}
                    </td>
                    <td>
                      <input class="input-style" v-model="fuel.price" type="number" />
                    </td>
                    </tr>
                  </tbody>
                </table>
                <div class="field col-12 md:col-12 p-2"></div>
                <div>
                  <label>{{ $t("variousCosts") }}<strong> (€)</strong>:</label>
                  <input
                    v-model="item.postModVariousCosts"
                    type="number"
                    class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                  />
                </div>
              </div>

              <div class="field col-12 md:col-12 p-2"></div>
              <div style="text-align: right; padding-right: 10%;">
                <ButtonPrime @click="calc_values()" id="add-button" class="button">{{ $t("calculate") }}</ButtonPrime>
              </div>

              <!--Resultados-->
              <div style="padding-right: 20px; text-align: left;">
                <div class="field col-12 md:col-12 p-2"></div>
                <h2>{{ $t("results") }}:</h2>
                <div class="field col-12 md:col-12 p-2"></div>
                <div style="display: flex;">
                  <p for="yearOptions" style="padding-top: 20px; padding-right: 10px;"><strong>{{ $t("year") }}:</strong></p>
                  <DropdownPrime
                    id="yearOptions"
                    v-model="yearSelected"
                    :options="allYears"
                    class="field col-1 md:col-1"
                  />
                </div>
                <div class="input-box2">
                  <!--Fila de arriba-->
                  <div style="display: flex; justify-content: space-around;">
                    <div class="field col-12 md:col-2 text-left">
                      <label>{{ $t("annualFuelCost") }}<strong> (€)</strong>:</label>
                      <p
                        id="annualFuelCost"
                        class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                      >{{ item.annualFuelCost }}</p>
                    </div>
                    <div class="field col-12 md:col-2 text-left">
                      <label>{{ $t("variationVariousCosts") }}:</label>
                      <p
                        id="variationVariousCosts"
                        class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                      >{{ item.variationVariousCosts }}</p>
                    </div>
                    <div class="field col-12 md:col-2 text-left">
                      <label>{{ $t("loanInterests") }}:</label>
                      <p
                        id="loanInterests"
                        class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                      >{{ item.loanInterests }}</p>
                    </div>
                  </div>
                  <!--Fila de abajo-->
                  <div style="display: flex; justify-content: space-around;">
                    <div class="field col-12 md:col-2 text-left">
                      <label>{{ $t("annualProfitability") }}:</label>
                      <p
                        id="annualProfitability"
                        class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                      >{{ item.annualProfitability }}</p>
                    </div>
                    <div class="field col-12 md:col-2 text-left">
                      <label>{{ $t("van") }}:</label>
                      <p
                        id="van"
                        class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                      >{{ item.van }}</p>
                    </div>
                    <div class="field col-12 md:col-2 text-left">
                      <label>{{ $t("paralizationCost") }}<strong> (€)</strong>:</label>
                      <p
                        id="paralizationCost"
                        class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                      >{{ item.paralizationCost }}</p>
                    </div>
                  </div>
                  
                </div>

              </div>

            </div>
          </div>

          <div class="field col-12 md:col-12 p-2"></div>
          <div style="padding-left: 70%;">
            <ButtonPrime @click="save()" id="add-button" class="button">{{ $t("save") }}</ButtonPrime>
            &ensp; &ensp; &ensp; &ensp;
            <ButtonPrime @click="cancel()" id="add-button" class="button">{{ $t("cancel") }}</ButtonPrime>
          </div>

          <div class="field col-12 md:col-12 p-2"></div>
          <div class="field col-12 md:col-12 p-2"></div>
          <div class="field col-12 md:col-12 p-2"></div>
          <div class="field col-12 md:col-12 p-2"></div>
          <div class="field col-12 md:col-12 p-2"></div>
          <div class="field col-12 md:col-12 p-2"></div>
          <div class="field col-12 md:col-12 p-2"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from "@/router/index";
import store from "@/store/index";
import { ToastSeverity } from "primevue/api";
import ShipService from "@/services/ShipService";
import NeobuqEconomicService from "@/services/Neobuq/NeobuqEconomicService";
import ModificationService from "@/services/Neobuq/ModificationService";

export default{
    data(){
      return{
        ship: store.getters.currentShip,
        fuelConsumptionArray : store.getters.currentShip.fuelConsumption,
        modification: store.getters.currentModification,

        initialInvestment : 0,
        optionsFinancing: ["Yes", "No"],
        selectedFinancingOption : "No",
        amountToFinance : 0,
        nominalInterest : 0,
        amortizationPeriod : 0,
        annualDiscountRate : 0,
        dailyIncome : 0,
        paralizationDays : 0,
        annualFuelPriceIncrease : 2,

        allYears: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15],
        yearSelected: 1,

        dataPerYear : []
      }
    },

    created(){
      this.shipService = ShipService.getInstance();
      this.economicService = NeobuqEconomicService.getInstance()

      //creamos el array de los datos económicos para cada año
      for(let i=0; i< this.allYears.length; i++){

        let fuelsPreMod = []
        let fuelsPostMod = []

        for(let j=0; j< this.fuelConsumptionArray.length; j++){
            var aux1 = {fuel: this.fuelConsumptionArray[j].fuel, consumption: this.fuelConsumptionArray[j].consumption, price : 0}
            fuelsPreMod.push(aux1)
        }

        for(let k=0; k< this.modification.newFuelConsumption.length; k++){
            var aux2 = {fuel: this.modification.newFuelConsumption[k].fuel, consumption: this.modification.newFuelConsumption[k].consumption, price : 0}
            fuelsPostMod.push(aux2)
        }

        var aux = {
            year : i+1,
            fuelsPreMod: fuelsPreMod,
            fuelsPostMod : fuelsPostMod,
            preModVariousCosts : 0,
            postModVariousCosts : 0,
            annualFuelCost : 0,
            variationVariousCosts : 0,
            loanInterests : 0,
            annualProfitability : 0,
            van : 0,
            paralizationCost : 0,
        }

        this.dataPerYear.push(aux)
      }
        

      if(Object.keys(this.modification.economicData).length != 0){
        this.dataPerYear = this.modification.economicData.dataPerYear
        this.initialInvestment = this.modification.economicData.initialInvestment
        this.amountToFinance = this.modification.economicData.amountToFinance
        this.nominalInterest = this.modification.economicData.nominalInterest
        this.amortizationPeriod = this.modification.economicData.amortizationPeriod
        this.annualDiscountRate = this.modification.economicData.annualDiscountRate
        this.dailyIncome = this.modification.economicData.dailyIncome
        this.paralizationDays = this.modification.economicData.paralizationDays
        this.annualFuelPriceIncrease = this.modification.economicData.annualFuelPriceIncrease
      }
    },

    computed:{ 
      filteredDataPerYear(){
        return this.dataPerYear.filter(item => item.year === this.yearSelected);
      }
    },

    methods:{

      calc_values(){
        //console.log("Calculamos los datos económicos de esta modificación...")

        if(this.selectedFinancingOption == "No"){
          this.amountToFinance = 0
        }

       //creamos un objeto de tipo NeobuqEconomicData
        var economicData = {
          dataPerYear : this.dataPerYear,
          initialInvestment : this.initialInvestment,
          amountToFinance : this.amountToFinance,
          nominalInterest : this.nominalInterest,
          amortizationPeriod : this.amortizationPeriod,
          annualDiscountRate : this.annualDiscountRate,
          dailyIncome : this.dailyIncome,
          paralizationDays : this.paralizationDays,
          annualFuelPriceIncrease : this.annualFuelPriceIncrease,
        }

        //nosotros queremos obtener los resultados de los valores de 'dataPerYear' para todos los años 
        //(si rellenamos 1 año, el resto de años también lo harán, con los datos que hemos introducido)
        //sobreescribiremos los valores de 'this.dataPerYear' para que se muestren en pantalla

        //this.dataPerYear = this.economicService.calc_economic_values(economicData)
       // this.economicService.calc_economic_values(economicData, this.selectedFinancingOption)
        this.modification.economicData = this.economicService.calc_economic_values(economicData, this.selectedFinancingOption)
        this.dataPerYear = this.modification.economicData.dataPerYear

      },

      save(){
        // console.log("Guardamos los datos económicos de esta modificación...")

        // console.log("store.getters.currentModification")
        // console.log(store.getters.currentModification)

        const errors = ModificationService.getInstance().saveModification(
          store.getters.currentShip.id,
          store.getters.currentModification
        );

        if (errors != "") {
          this.showToast(false, "Error guardando la modificación: " + errors);
        } else {
          this.showToast(true, "Modificación salvada correctamente");
        }

      },

      cancel(){
        // console.log("Cancelamos el proceso...")
        // console.log("NeobuqEconomicForm-cancel", this.ship);
        this.shipService.selectedShip({});
        router.push({ name: "neobuqHome" });
      },

      showToast(successful, message) {
      if (successful) {
        this.$toast.add({
          severity: ToastSeverity.SUCCESS,
          closable: false,
          summary: message,
          life: 3000,
        });
      } else {
        this.$toast.add({
          severity: ToastSeverity.ERROR,
          closable: false,
          summary: message,
          life: 3000,
        });
      }
    },
    }

}

</script>

<style scoped>

.input-box{
  border-style: dotted;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 20px;
}

.input-box2{
  border-style: dotted;
  padding: 20px;
}

.output-box{
  border-style: solid;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 20px;
}

.button{
  height: 70px;
  border-radius: 20px;
  text-align: center;
}

/*PARA LA TABLA */
.styled-table {
  width: 100%;
  border-collapse: collapse;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  margin: 20px 0;
}

.styled-table th,
.styled-table td {
  padding: 16px 15px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

.styled-table th {
  background-color: #f2f2f2;
}

.styled-table tbody tr:last-child td {
  border-bottom: none;
}

.styled-table tbody tr:hover {
  background-color: #f5f5f5;
}

.input-style{
    border-radius: 5px;
    height: 40px;
    width: 250px;
}

</style>